var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalPageLayout',{attrs:{"title":_vm.$t('privacy policy').toString(),"content":_vm.privacyPolicyFull}})}
var staticRenderFns = []

export { render, staticRenderFns }